import { render, staticRenderFns } from "./betHistory.vue?vue&type=template&id=063c0d62&scoped=true"
import script from "./betHistory.vue?vue&type=script&lang=js"
export * from "./betHistory.vue?vue&type=script&lang=js"
import style0 from "./betHistory.vue?vue&type=style&index=0&id=063c0d62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c0d62",
  null
  
)

export default component.exports